import { styled, useBreakpointIndex } from 'dripsy';
import React, { ReactNode } from 'react';
import { StyleSheet, View, ViewProps } from 'react-native';

const Container = styled(View)({
  width: ['100%', 'auto'],
});

const Background = styled(View)({
  ...StyleSheet.absoluteFillObject,
  top: '$14',
  bottom: '$14',
  backgroundColor: ['transparent', null, null, null, '$background10'],
  borderRadius: 26,
});

const ItemsContainer = styled(View)({
  flexDirection: ['column', null, null, null, 'row'],
});

export interface ISubscriptionPlansLayoutProps extends ViewProps {
  children: ReactNode[];
}

export function SubscriptionPlansLayout({
  children,
}: ISubscriptionPlansLayoutProps) {
  const bIndex = useBreakpointIndex();
  return (
    <Container>
      {bIndex > 2 && <Background />}
      <ItemsContainer>{children}</ItemsContainer>
    </Container>
  );
}
